import React, { useEffect, useState } from "react";
import { Box, HStack, Text, VStack } from "@chakra-ui/react";
import { FreeResponseText } from "components";
import type { NullableCheckboxState } from "components/NullableCheckbox/types";
import { useAssessmentContext } from "hooks/assessment";
import Checkbox from "./Checkbox";

interface SubtopicProps {
  tags: string[]; // may be replaced with ID in future
  //id: string;
  description: string;
  hasText: boolean;
  toggleGameLiftStreamsInput: any;
}

const Subtopic: React.FC<SubtopicProps> = ({ tags, description, hasText, toggleGameLiftStreamsInput }) => {
  // NOTE: Checkbox and FreeResponseText save their state in
  // the same object retrieved with getValue(tags).
  // The checkbox saves its state on the 'value' key, and the
  // free response text is on the optional 'data' key.

  // it looks like this:

  //    {
  //      someJsonPathWithText: {
  //        value: true,
  //        data: " Some Text",
  //        updatedAt: "Some date"
  //      }
  //    }

  // get initial value from assessment context
  const { getValue, saveDataResponse } = useAssessmentContext();

  // set our textbox state from our responses
  // set exactly once
  const [initData, setInitData] = useState<string>("");

  const handleTextChange = (tags: string[], textValue: string) => {
    // Do NOT setInitState, as that will re-render the
    // NullableCheckbox Component
    //setInitState(checkboxValue);

    // if/when we change to relational db schema, call the api directly from here
    // to update the value
    saveDataResponse(tags, textValue);
  };

  const getCachedValue = async (tags: string[]) => {
    // if/when we change to relational db schema, call the api directly from here
    // to retrieve the value stored in db
    return getValue(tags);
  };

  useEffect(() => {
    if (hasText) {
      getCachedValue(tags)
        .then(initialValue => {
          setInitData(initialValue?.data);
        });
    }
  }, []);

  return (
    <Box>
      <HStack width="100%" align="left">
        <Checkbox tags={tags} />
        <VStack align="left">
          <Text align="left" fontWeight="300" fontSize="12px">
            {description}
          </Text>
          {hasText &&
            (<FreeResponseText
              messageBody={initData}
              onMessageBodyChange={(a: any) => { }}
              saveMessage={(textValue: string) => handleTextChange(tags, textValue)} // TODO replace these dummy fn's
              toggleGameLiftStreamsInput={toggleGameLiftStreamsInput}
            />)
          }
        </VStack>
      </HStack>
    </Box>
  );

};

export default Subtopic;
